class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._closeTimer = null;
    this.GRACE_MS = 150;

    this.addEventListener('mouseenter', this._onEnter.bind(this));
    this.addEventListener('mouseleave', this._onLeave.bind(this));
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', this._onSummaryClick.bind(this));
  }

  _onEnter() {
    clearTimeout(this._closeTimer);
    // Cancel any in-progress close animation so it doesn't fight the open state
    const submenu = this.mainDetailsToggle.querySelector('.header__submenu');
    if (submenu) submenu.classList.remove('is-closing');
    this.mainDetailsToggle.open = true;
  }

  _onLeave() {
    this._closeTimer = setTimeout(() => this._animateClose(), this.GRACE_MS);
  }

  _animateClose() {
    const submenu = this.mainDetailsToggle.querySelector('.header__submenu');
    if (!submenu || !this.mainDetailsToggle.open) return;

    submenu.classList.add('is-closing');
    submenu.addEventListener(
      'animationend',
      () => {
        submenu.classList.remove('is-closing');
        this.close();
      },
      { once: true }
    );
  }

  // Redirect to the parent URL instead of toggling the dropdown
  _onSummaryClick(e) {
    const url = e.currentTarget.dataset.url;
    if (url) {
      e.preventDefault();
      window.location.href = url;
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
